import CatalogItem from '../helperTypes/CatalogItem';

export type CoverageLimit = {
  id: string;
  value: number;
};

export type CoverageCustomizable = {
  code: string;
  name: string;
  limits: CoverageLimit[];
  options: CatalogItem[];
  defaultValue: CatalogItem;
};

export const makeEmptyCoverageCustomizable = (): CoverageCustomizable => ({
  code: '',
  defaultValue: {
    Text: '',
    Value: '',
  },
  limits: [],
  name: '',
  options: [],
});
